import UnstyledDrawer from '@mui/material/Drawer';
import { styled } from '@mui/material/styles';

import { desktopMediaQuery, tabletMediaQuery } from '@/utils/mediaQuery';

const drawerWidth = 320;
const collapsedWidth = 80;

const isDesktop = `@media ${desktopMediaQuery}`;
const isTablet = `@media ${tabletMediaQuery}`;

export const Drawer = styled(UnstyledDrawer)(({ theme, open }) => ({
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    backgroundColor: theme.palette.background.default,
    transition: 'width 0.3s ease-in-out',
    boxSizing: 'border-box',
    borderRight: 'none',
    padding: '24px',
    width: '100%',
  },
  [isTablet]: {
    '& .MuiDrawer-paper': {
      width: 360,
      borderRadius: '0 12px 12px 0',
    },
  },
  [isDesktop]: {
    '& .MuiDrawer-paper': {
      backgroundColor: 'transparent',
      position: 'relative',
      width: open ? drawerWidth : collapsedWidth,
      padding: 0,
    },
  },
}));
